$(document).on('submit', '.process-payment', (e) => {
  validationAndSubmission(e);
});


function validationAndSubmission(e) {
    e.preventDefault();
    let $target = $(e.target);
    let $article = $target.find("article");
    let $input =  $article.find(".check-number");
    let $cancelButton = $article.find(".cancel");

    if ($input.val() == "" && !$input.parent().hasClass("field_with_errors")){
        //Add Error Validations if empty
        $input.addClass("error-input-table-like");
        $input.wrap( "<div class='field_with_errors'></div>" );
        $input.parent().parent().append("<div class=\"input-error-message input-error-extra-padding\"><ul><li class=\"error-item\">You must input a value.</li></ul></div>");
        $input.on("keydown", () =>{
            // $input.parent().removeClass("field_with_errors");

            $article.parent().find(".input-error-message").fadeOut(600, ()=>{
                $input.removeClass("error-input-table-like");
                $input.unwrap("div.field_with_errors");
                $input.trigger("focus")

            });
        });
        $cancelButton.on("click", ()=>{
            $article.find(".input-error-message").fadeOut(600, ()=>{
                $input.removeClass("error-input-table-like");
                $input.unwrap("div.field_with_errors");
            });
        })
    }
    else{
        $article.find(".spinner-container").toggleClass("hide");
        $article.find(".submit-payment").toggleClass("hide");
        $target.trigger("asyncFormSubmit")
    }

}


